export default {
	attributes: {
		design: 'basic',
		containerBackgroundCustomSizeUnit: '%',
		containerTabletBackgroundCustomSizeUnit: '%',
		containerMobileBackgroundCustomSizeUnit: '%',
		showQuote: true,
		quoteIcon: 'round-thin',
		quoteSize: 70,
		text: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block.',
		textLineHeightUnit: 'em',
		textTabletLineHeightUnit: 'em',
		textMobileLineHeightUnit: 'em',
		uniqueClass: 'ugb-ceaa0fe',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
	},
}
